import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import LaunchHeader from "./LaunchHeader";
import Footer from "./Footer";

const styles = theme => ({
  
    paper: {
        padding: theme.spacing.unit * 2,
        boxShadow: 'none',
    },

    banner: {
        color: '#fff',
        paddingTop: 100,
        paddingBottom: 150,
        background: `url("${require("../assets/5.jpg")}")`,
        backgroundSize: 'cover',
        position: 'relative',
        zIndex: 1,        
        // '&:before': {
        //     background: `url("${require("../assets/hero-banner-bg.png")}")`,
        //     backgroundSize: 'cover',
        //     position: 'relative',
        //     zIndex: 1
        // },
        '&:after': {            
            content: "no-open-quote",
            background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
            // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
            // background: 'linear-gradient(to right, #2926ac 0%, #0a0a0a 100%)',
            display: 'block',
            zIndex: -1,
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '100%',
            opacity: 0.8
        }
    },
   
    centerText: {
        textAlign: 'center'
    },

    container: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',
        //top: 100,
        zIndex: 1,
        // width: 400
    },

    contentContainer: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing.unit * 2,
        paddingBottom: theme.spacing.unit * 2,
        position: 'relative',
        // top: -100,
        zIndex: 2,
        // color: '#fff'
        // width: 400
    },

    // sectionMargin: {
    //     top: -50
    // },

    content: {
        flexGrow: 1,
        padding: theme.spacing.unit * 2,
        background: 'linear-gradient(to right, #2926ac 0%, #6128be 100%)',

    },

    // paper: {
    //     padding: theme.spacing.unit * 2,
    //     // textAlign: 'center',
    //     boxShadow: 'none'
    //     // color: theme.palette.text.secondary,
    // },

    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('md')]: {
            display: 'flex',
        },
    },

    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('md')]: {
            display: 'none',
        },
    },

    
});

class Layout extends Component {
    static contextTypes = {
        router: PropTypes.object,
    }

    defaultMenu(){
        let url = window.location.pathname.split ('/')[1];
        let menu = url === "alllibraries" ? 1 : url === "fllteams" ? 2 : 0
        return menu;
    }

    render() {
        const {  classes, children } = this.props;

        return (
            <div>
                <LaunchHeader />
                <section className={`${classes.content} ${classes.sectionMargin}`}>
                   <div className={`${classes.contentContainer}`}>
                        {/* <Paper className={classes.paper} style={{marginTop: 150}}> */}
                            {children}
                        {/* </Paper>                         */}
                   </div>                    
                </section>  
                <Footer />
            </div>
        )
    }
}

Layout.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Layout);